import { useTimezone } from '@app/core/hooks/useTimezone';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_UI_CONFIG } from '../../consts';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { ThumbnailsStreamV2 } from './ThumbnailsStreamV2';
import { useLoggerRangeThumbnails } from './hooks/useLoggerRangeThumbnails';

export const LoggerVideoPreview = () => {
  const { thumbnails, isLoading } = useLoggerRangeThumbnails();
  const range = useStreamSegmentsRange();
  const tz = useTimezone();

  const streamProps = {
    compressed: true as const,
    tz,
    height: STREAM_UI_CONFIG.previewHeight,
    range,
    hideSeconds: true as const,
    disableHtmlEvents: true as const,
    renderSvg: () => <PreviewBrush />,
    renderHtml: () => <PreviewFocusMarkers />,
    thumbnails,
    thumbnailsLoading: isLoading,
  };

  return (
    <PreviewWrapper
      data-testid="logger-video-preview"
      data-range-from={range.from}
      data-range-to={range.to}
    >
      <ThumbnailsStreamV2 {...streamProps} />
    </PreviewWrapper>
  );
};
